import { Datagrid, DateInput, List, BooleanInput, TextField, useTranslate, TextInput } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import dayjs from "dayjs";

import { FrontUserStatisticListActions } from "./components/FrontUserStatisticListActions";
import { FrontUserStatusField } from "./FrontUserStatusField";

export function FrontUserStatisticList(): JSX.Element {
    const t = useTranslate();
    const formatedStartDate = dayjs().startOf("year").format("YYYY-MM-DD");
    const formatedEndDate = dayjs().endOf("year").format("YYYY-MM-DD");

    const filters = [
        <TextInput key="filter-fulltext" label={t("resources.frontUserStatistic.filters.fullText")} source="fullText" alwaysOn />,
        <DateInput key="start-date" source="startDate" label={t("resources.frontUserStatistic.filters.startDate")} />,
        <DateInput key="end-date" source="endDate" label={t("resources.frontUserStatistic.filters.endDate")} />,
        <BooleanInput key="test-account" label={t("resources.frontUserStatistic.filters.testAccount")} source="testAccount" />,
        <BooleanInput key="archived" label={t("resources.frontUserStatistic.filters.anonymized")} source="archived" />
    ];

    return (
        <List
            pagination={<ListPagination />}
            perPage={20}
            filters={filters}
            filterDefaultValues={{ startDate: formatedStartDate, endDate: formatedEndDate }}
            actions={<FrontUserStatisticListActions />}
        >
            <Datagrid rowStyle={rowStyles}>
                <TextField source="accountId" label={t("resources.frontUserStatistic.fields.accountId")} />
                <TextField source="email" label={t("resources.frontUserStatistic.fields.email")} />
                <TextField source="username" label={t("resources.frontUserStatistic.fields.username")} />
                <TextField source="lastLoginAt" label={t("resources.frontUserStatistic.fields.lastLoginDate")} />
                <TextField source="lastConsumptionAt" label={t("resources.frontUserStatistic.fields.lastConsumptionDate")} />
                <FrontUserStatusField source="archived" label={t("resources.frontUserStatistic.fields.status")} />
                <TextField source="createdAt" label={t("resources.frontUserStatistic.fields.creationDate")} />
                <TextField source="deletedAt" label={t("resources.frontUserStatistic.fields.anonymizationDate")} />
            </Datagrid>
        </List>
    );
}
